import React, { useState, useEffect } from 'react';

import './TitleAndContentCard.css';

function TitleAndContentCard({ title, content, width, height, onClick }) {

    return (
        <div className='feature-box' style={{width: width, height:height}} onClick={onClick}>
            <h5>{title}</h5>
            <p>{content}</p>
        </div>
    );
}

export default TitleAndContentCard;
